import React, { useEffect } from 'react';
import { 
  FaFileAlt, 
  FaArrowLeft, 
  FaCheckCircle, 
  FaGraduationCap, 
  FaIdBadge, 
  FaBook, 
  FaShieldAlt, 
  FaSync,
  FaBalanceScale,
  FaUserFriends
} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import style from './AIPolicyAppendix2.module.css';

const AIPolicyAppendix2 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={style.pageContainer}>
      <header className={style.header}>
        <div className={style.headerContent}>
          <Link to="/ai-policy" className={style.backLink}>
            <FaArrowLeft /> Politika Belgesine Dön
          </Link>
          <div className={style.badge}>
            <FaFileAlt className={style.badgeIcon} />
            <span>EK–2: MAARİF MODELİ UYUMU</span>
          </div>
          <h1 className={style.title}>Türkiye Yüzyılı Maarif Modeli <br/> ile Uyum Değerlendirmesi</h1>
          <p className={style.subtitle}>
            MEB, kamu ve denetim süreçleri için pedagojik, beceri temelli ve bütüncül uyum raporu.
          </p>
        </div>
      </header>

      <main className={style.mainContent}>
        <section className={style.introSection}>
          <div className={style.purposeHeader}>
            <div className={style.pIcon}>🎯</div>
            <h2>Amaç ve Kapsam</h2>
          </div>
          <p>Bu ek doküman; Talent14 Yapay Zekâ Politika Belgesi’nin, Türkiye Yüzyılı Maarif Modeli kapsamında tanımlanan eğitim felsefesi, beceri temelli yaklaşım ve bütüncül öğrenci profili ile uyumunu ortaya koymak amacıyla hazırlanmıştır.</p>
          <p>EK–2, Talent14’ün yapay zekâyı eğitim sürecinin yerine koymadığını; aksine Maarif Modeli’nin öngördüğü pedagojik hedefleri destekleyen, sınırlayan ve güvence altına alan bir araç olarak konumlandırdığını göstermeyi hedefler.</p>
          <div className={style.refBox}>
            <strong>Denetim Vurgusu:</strong> Bu doküman, özellikle MEB, kamu kurumları ve denetim süreçleri için referans niteliğindedir.
          </div>
        </section>

        <section className={style.section}>
          <div className={style.sectionHeader}>
            <span className={style.sectionNumber}>1️⃣</span>
            <h2>Türkiye Yüzyılı Maarif Modeli – Temel Çerçeve</h2>
          </div>
          <div className={style.frameworkGrid}>
            <div className={style.fwCard}>
              <FaUserFriends /> <span>İnsan merkezli eğitim anlayışı</span>
            </div>
            <div className={style.fwCard}>
              <FaIdBadge /> <span>Bütüncül öğrenci profili</span>
            </div>
            <div className={style.fwCard}>
              <FaGraduationCap /> <span>Beceri temelli öğrenme</span>
            </div>
            <div className={style.fwCard}>
              <FaShieldAlt /> <span>Değerler ve etik sorumluluk</span>
            </div>
            <div className={style.fwCard}>
              <FaSync /> <span>Süreç odaklı öğrenme</span>
            </div>
            <div className={style.fwCard}>
              <FaBook /> <span>Öğretmenin pedagojik liderliği</span>
            </div>
            <div className={style.fwCard}>
              <FaBalanceScale /> <span>Ölçme–değerlendirmede insan rolü</span>
            </div>
          </div>
          <p className={style.frameworkNote}>Bu unsurlar, yapay zekâ dâhil tüm eğitim teknolojilerinin nasıl ve hangi sınırlar içinde kullanılacağını belirleyen ana referans çerçeveyi oluşturur.</p>
        </section>

        <section className={style.section}>
          <div className={style.sectionHeader}>
            <span className={style.sectionNumber}>2️⃣</span>
            <h2>Talent14 Yapay Zekâ Politika İlkeleri (Referans)</h2>
          </div>
          <div className={style.principlesRef}>
            <p>Talent14 Yapay Zekâ Politika Belgesi; yapay zekânın pedagojik hedeflere hizmet eden, etik ve kontrollü bir araç olarak konumlandırılmasını sağlayan 10 temel ilke üzerine inşa edilmiştir.</p>
            <ul className={style.principleList}>
              <li>Bilinçli Araç Kullanımı</li>
              <li>Üretim Odaklı Yetkinlik</li>
              <li>İnsan Merkezlilik</li>
              <li>Etki Odaklılık</li>
              <li>Kaynak Farkındalığı</li>
              <li>Yaş Duyarlılığı</li>
              <li>Tam Şeffaflık</li>
              <li>Öğrenme Önceliği</li>
              <li>Etik Güvence</li>
              <li>Yaşayan Politika</li>
            </ul>
          </div>
        </section>

        <section className={style.section}>
          <div className={style.sectionHeader}>
            <span className={style.sectionNumber}>3️⃣</span>
            <h2>Maarif Modeli – Talent14 Uyum Matrisi</h2>
          </div>
          <div className={style.tableWrapper}>
            <table className={style.matrixTable}>
              <thead>
                <tr>
                  <th>Maarif Modeli Bileşeni</th>
                  <th>İlgili Talent14 İlkeleri</th>
                  <th>Uyum Açıklaması</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><strong>İnsan Merkezlilik</strong></td>
                  <td>3, 8, 9</td>
                  <td>Yapay zekâ destekleyici, nihai karar insanda</td>
                </tr>
                <tr>
                  <td><strong>Beceri Temelli Eğitim</strong></td>
                  <td>2, 4</td>
                  <td>Üretim ve süreç odaklı öğrenme</td>
                </tr>
                <tr>
                  <td><strong>Bütüncül Öğrenci Profili</strong></td>
                  <td>6, 8</td>
                  <td>Yaş ve gelişim düzeyine duyarlı yapı</td>
                </tr>
                <tr>
                  <td><strong>Değerler ve Etik</strong></td>
                  <td>9, 7</td>
                  <td>Etik, güvenlik ve şeffaflık güvencesi</td>
                </tr>
                <tr>
                  <td><strong>Öğretmen Liderliği</strong></td>
                  <td>3, 8</td>
                  <td>Yapay zekâ rehber, öğretmen lider</td>
                </tr>
                <tr>
                  <td><strong>Süreç Odaklı Öğrenme</strong></td>
                  <td>1, 4</td>
                  <td>Öğrenme süreci öncelikli kullanım</td>
                </tr>
                <tr>
                  <td><strong>Sorumluluk ve Şeffaflık</strong></td>
                  <td>7, 10</td>
                  <td>İzlenebilir, denetlenebilir ve güncellenebilir yapı</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section className={style.section}>
          <div className={style.sectionHeader}>
            <span className={style.sectionNumber}>4️⃣</span>
            <h2>Açıklamalı Uyum Değerlendirmesi</h2>
          </div>
          <div className={style.explGrid}>
            <EvalCard 
              num="4.1"
              title="İnsan Merkezlilik ve Öğretmen Liderliği"
              expect="Eğitim sürecinde öğretmenin pedagojik liderliğinin korunmasını, öğrencinin ise aktif ve sorumlu bir öğrenen olmasını esas alır."
              response="Talent14 Yapay Zekâ Politikası, insan merkezlilik ve öğrenme önceliği ilkeleriyle yapay zekâyı karar verici değil, destekleyici bir araç olarak konumlandırır."
              conclusion="Yapay zekâ, öğretmenin yönettiği öğrenme sürecini güçlendirir; pedagojik kararların yerine geçmez."
            />
            <EvalCard 
              num="4.2"
              title="Beceri Temelli ve Üretim Odaklı Öğrenme"
              expect="Öğrencinin düşünme, üretme, problem çözme ve anlamlandırma becerilerini geliştirmeyi hedefler."
              response="Üretim odaklı yetkinlik ve etki odaklılık ilkeleriyle yapay zekâ; nihai ürün üretmez, öğrenme ve üretim sürecini destekler."
              conclusion="Yapay zekâ, öğrencinin üretim sürecine rehberlik eden bir öğrenme destek aracıdır."
            />
            <EvalCard 
              num="4.3"
              title="Yaş Duyarlılığı ve Bütüncül Gelişim"
              expect="Öğrencilerin yaş, gelişim ve duygusal özelliklerinin gözetilmesini öngörür."
              response="Yaş duyarlılığı ve öğrenme önceliği ilkeleriyle yapay zekâ kullanımı kademelere göre yapılandırılır."
              conclusion="Yapay zekâ, yaşa uygun, güvenli ve yönlendirici bir öğrenme ortamı sunar."
            />
            <EvalCard 
              num="4.4"
              title="Etik, Güvenlik ve Sorumluluk"
              expect="Eğitimde etik değerlerin, güvenliğin ve sorumluluğun korunmasını esas alır."
              response="Etik güvence, tam şeffaflık ve yaşayan politika ilkeleriyle yapay zekâ kullanımı izlenir, denetlenir ve yönetilir."
              conclusion="Yapay zekâ, etik ve güvenlik sınırları içinde, insan denetimi altında çalışır."
            />
          </div>
        </section>

        <section className={style.finalSection}>
          <div className={style.sectionHeader}>
            <span className={style.sectionNumber}>5️⃣</span>
            <h2>Genel Değerlendirme ve Sonuç</h2>
          </div>
          <div className={style.resultCard}>
            <p>Bu değerlendirme sonucunda, Talent14 Yapay Zekâ Politika Belgesi’nin; <strong>Türkiye Yüzyılı Maarif Modeli’nin</strong> öngördüğü insan merkezli, beceri temelli, etik ve süreç odaklı eğitim anlayışıyla uyumlu olduğu görülmektedir.</p>
            <p>Talent14, yapay zekâyı eğitim felsefesinin yerine koyan bir sistem olarak değil; Maarif Modeli’nin hedeflerini destekleyen, sınırlayan ve yöneten bir araç olarak konumlandırmaktadır.</p>
            <p className={style.finalNote}>Bu yönüyle EK–2, Talent14 Yapay Zekâ Politika Belgesi’nin ulusal eğitim politikalarıyla uyumunu belgeleyen tamamlayıcı bir dokümandır.</p>
          </div>
        </section>
      </main>

      <footer className={style.pageFooter}>
        <div className={style.footerContent}>
          <p>© {new Date().getFullYear()} Talent14 - Türkiye Yüzyılı Maarif Modeli Uyumluluk Raporu</p>
        </div>
      </footer>
    </div>
  );
};

const EvalCard = ({ num, title, expect, response, conclusion }) => (
  <div className={style.evalCard}>
    <div className={style.evalHead}>
      <span className={style.evalNum}>{num}</span>
      <h3>{title}</h3>
    </div>
    <div className={style.evalContent}>
      <div className={style.evalRow}>
        <strong>Maarif Modeli Ne Bekler?</strong>
        <p>{expect}</p>
      </div>
      <div className={style.evalRow}>
        <strong>Talent14 Nasıl Karşılar?</strong>
        <p>{response}</p>
      </div>
      <div className={style.evalResult}>
        <FaCheckCircle />
        <div>
          <strong>Yapay Zekânın Konumu</strong>
          <p>{conclusion}</p>
        </div>
      </div>
    </div>
  </div>
);

export default AIPolicyAppendix2;
